import React, { Component } from 'react';
import { connect } from 'react-redux';

import { closeSliderModal } from '../redux/actions/placesModalActions';

export default function withPlacesModalClose(WrappedComp) {
  class PlacesModalClose extends Component {
    render() {
      return <WrappedComp {...this.props} />;
    }
  }
  return connect(
    null,
    { closeSliderModal }
  )(PlacesModalClose);
}



// WEBPACK FOOTER //
// ./src/HOCs/withPlacesModalClose.jsx